import React, { useState } from "react";
import "../../styles/Brands-p.css";

const importAll = (r) => {
  return r.keys().map(r);
};

const images = importAll(
  require.context("../../img/brands/spotify/", false, /\.(webp|jpg|jpeg|png)$/)
);

const Spotify = () => {
  const [zoomedImg, setZoomedImg] = useState(null); // Estado para controlar el zoom de las imágenes

  // Función para hacer zoom en la imagen
  const handleImageClick = (image) => {
    setZoomedImg(image);
  };

  // Función para cerrar el zoom
  const handleCloseZoom = () => {
    setZoomedImg(null);
  };

  return (
    <div className="netflix-gallery">
      {/* Título y subtítulo */}
      <div className="gallery-header">
        <h1 className="gallery-title">Spotify</h1>
        <h2 className="gallery-subtitle">
          <span className="agency-title">Productora </span> Suena Eh!
        </h2>
        <h2 className="gallery-text">          Suena Eh is a music label with their own record studio, promoting and
          believing in diversity. It develops in the corner near Villa Cava, one
          of the biggest slums in Argentina, bordering the rest of the district
          of San Isidro, which is one of the most prestigious neighborhoods in
          Buenos Aires. That's why Suena Eh can understand urban music in all
          its aspects and angles. Inside the space producers, creatives,
          filmmakers, designers, musicians and artists coexist. This makes Suena
          Eh an unique team, where artists and their products improve/ maximize
          each other. They record more than thirty artists and post their
          contents on all and different digital platforms.</h2>
      </div>
      {/* Galería de imágenes */}
      <div className="brands-gallery">
        {images.map((image, index) => (
          <img
            key={index}
            src={image}
            alt={`Brand ${index}`}
            className={`brand-img img-${index % 5}`}
            onClick={() => handleImageClick(image)} // Al hacer clic, hacemos zoom
          />
        ))}
      </div>

      {/* Imagen con zoom */}
      {zoomedImg && (
        <div className="zoom-overlay" onClick={handleCloseZoom}>
          <img src={zoomedImg} alt="Zoomed" className="zoomed-img" />
        </div>
      )}
    </div>
  );
};

export default Spotify;
